import { Link } from '@remix-run/react';

import Text from '~/components/Text';

import NavGroupPopover from './NavGroupPopover';

interface Props {
  children: React.ReactNode;
  subLinks: any;
}

const LinkPopover = ({ children, subLinks }: Props) => {
  return (
    <NavGroupPopover
      popoverContent={
        // biome-ignore lint/complexity/noUselessFragments: Otherwise it will error because of the ternary
        <>
          {subLinks.map((sublink: any) => {
            const isExternalLink = sublink.external_link;

            if (isExternalLink) {
              return (
                <a
                  key={sublink.id}
                  className="flex rounded-wt px-3 py-2.5 hover:bg-black/5"
                  href={sublink.href}
                  target="_blank"
                  rel="nofollow noreferrer noopener"
                >
                  <Text as="span" type="title" theme="navs" className="text-xs sm:block">
                    {sublink.cta_text}
                  </Text>
                </a>
              );
            }

            return (
              <Link key={sublink.id} className="flex rounded-wt px-3 py-2.5 hover:bg-black/5" to={`/c/${sublink.href}`}>
                <Text as="span" type="title" theme="navs" className="text-xs sm:block">
                  {sublink.cta_text}
                </Text>
              </Link>
            );
          })}
        </>
      }
    >
      {children}
    </NavGroupPopover>
  );
};

export default LinkPopover;
